<template lang="pug">

div

    //- Navigation
    navigation

    //- MOCO-Konfiguration
    form.ui.form(v-on:submit.prevent='saveSettings')

        .ui.active.inline.loader(v-if='!settings')

        template(v-if='settings')
            .ui.info.message
                i.info.circle.icon
                | Felder mit * wirken erst nach einem Neustart des Services.

            template(v-for='(group, groupName) in groupedFields')
                .ui.top.attached.header
                    .content {{ groupName }}
                .ui.bottom.attached.segment
                    .grouped.fields
                        .field(v-for='field in group' v-bind:key='field.key')
                            template(v-if='field.type === "checkbox"')
                                .ui.checkbox
                                    input(
                                        type='checkbox'
                                        v-model='settings[field.key]'
                                    )
                                    label {{ field.label }}
                            template(v-else)
                                label
                                    | {{ field.label }}:
                                    span(v-if='field.requiresRestart' style='color: #db2828')  *
                                input(
                                    v-if='field.type === "text"'
                                    type='text'
                                    v-model='settings[field.key]'
                                )
                                input(
                                    v-else-if='field.type === "password"'
                                    type='password'
                                    autocomplete='new-password'
                                    v-model='settings[field.key]'
                                )
                                input(
                                    v-else
                                    type='number'
                                    step='any'
                                    v-model.number='settings[field.key]'
                                )

            button.ui.primary.labeled.icon.button(v-bind:class='{ loading: saving }' v-bind:disabled='saving' type='submit')
                i.save.icon
                | Speichern

</template>

<script>
    import store from '@/store'
    import { MOCO_SETTINGS_FIELDS, group_settings_fields, normalize_settings } from '@/utils/moco-settings'
    import Navigation from '@/components/settings/Navigation.vue'

    export default {
        name: 'settings',

        components: { Navigation },

        data() {
            return {
                saving: false,
                settings: null
            }
        },

        computed: {

            groupedFields() {
                return group_settings_fields(MOCO_SETTINGS_FIELDS)
            },

        },

        created() {
            this.loadSettings()
        },

        methods: {

            async loadSettings() {
                try {
                    const settings = await store.dispatch('settings/loadMocoSettings')
                    this.settings = { ...settings }
                } catch (e) {
                    this.$growl.error('MOCO-Einstellungen konnten nicht geladen werden')
                }
            },

            async saveSettings() {
                this.saving = true
                try {
                    const payload = normalize_settings(this.settings)
                    await store.dispatch('settings/saveMocoSettings', payload)
                    this.settings = { ...payload }
                    this.$growl.success('MOCO-Einstellungen wurden gespeichert')
                } catch (e) {
                    this.$growl.error('MOCO-Einstellungen konnten nicht gespeichert werden')
                } finally {
                    this.saving = false
                }
            },

        },

    }

</script>
